import React from "react";

export const Header = () => {
    return (
        
        <h1>ZERO HUNT</h1>
        
    )
}